"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WorkoutReaction;
(function (WorkoutReaction) {
    WorkoutReaction["BAD"] = "BAD";
    WorkoutReaction["OK"] = "OK";
    WorkoutReaction["GOOD"] = "GOOD";
    WorkoutReaction["GREAT"] = "GREAT";
})(WorkoutReaction || (WorkoutReaction = {}));
exports.default = WorkoutReaction;
//# sourceMappingURL=WorkoutReaction.js.map